export const PROCESS_UPLOADED_FILE = 'PROCESS_UPLOADED_FILE';
export const REMOVE_UPLOADED_FILE = 'REMOVE_UPLOADED_FILE';
export const GET_ALL_SEGMENT_TRACKER = 'GET_ALL_SEGMENT_TRACKER';
export const DELETE_SEGMENT = 'DELETE_SEGMENT';
export const DOWNLOAD_SEGMENT = 'DOWNLOAD_SEGMENT';
export const SEND_NOTIFICATION_ACTION = 'SEND_NOTIFICATION_ACTION';
export const SET_SEGMENT_OPERATION = 'SET_SEGMENT_OPERATION';
export const SET_SEGMENT_DATA = 'SET_SEGMENT_DATA';
export const UPDATE_SEGMENT_API_STATUS = 'UPDATE_SEGMENT_API_STATUS';
export const CLEAR_SEGMENT_DATA = 'CLEAR_SEGMENT_DATA';
